export default "__VITE_ASSET__Bys5yL42__"